
import { withStyles } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Button, Modal, Fade, FormGroup, FormControlLabel, InputBase } from '@material-ui/core';
import { HorizontalSp, VerticalSp, ModalContents, ModalTitle, ModalNorBtn, MediaQuery } from '../Common';
import { isMobile, isTablet } from 'react-device-detect';
import images from '../../assets';
import styled, { keyframes } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CheckBox, CheckMark } from '../auth/login';
import  { getModalWidh } from '../../_utils/modalWidh';

export const CustomHead = withStyles({
  root: {
    borderTop: '1px solid #cccccc',
    borderBottom: '1px solid #cccccc',
    backgroundColor: '#fafafa',
    height: 58,
  },
})(TableHead);

export const CustomBody = withStyles({
  root: {
    borderBottom: '1px solid #cccccc',
  },
})(TableBody);

export const CustomCell = withStyles({
  root: {
    // height: 66,
    minHeight: 66,
    border: 'none',
    '@media (max-width: 768px)': {
      height: 'auto',     // 모바일에서는 높이 자동
      padding: '8px 4px', // 패딩 줄여서 공간 확보
    },
  },
})(TableCell);

export const BodyCell = styled.div`
  font-family: 'NSCJKrR';
  font-size: clamp(0.625rem, 0.2344rem + 1.25vw, 0.9375rem);
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeadCell = styled.div`
  font-family: 'NSCJKrR';
  font-size: clamp(0.625rem, 0.3125rem + 1vw, 0.875rem);
  color: black;
  width: 'max-content';
`;

export const NoItemCell = styled.div`
  font-family: 'NSCJKrR';
  font-size: clamp(0.625rem, 0.2344rem + 1.25vw, 0.9375rem);
  color: black;
  text-align: center;
`;

export const rorateAnimation = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(-360deg);
}
`;
export const RotatedImage = styled.img`
  vertical-align:middle;
  animation: ${rorateAnimation} 2s linear infinite; /* Adjust the duration and timing function as needed */
`;

export const ItemRow = ({item, index, checkItemHandeler, checkboxes, goDetail}) => {

  const { t } = useTranslation();
  return(
  <>
  {item._status < 3 ? (
    <TableRow key={`list-${index}`} style={{borderBottom: '1px solid #cccccc',}}>
      <CustomCell width={'1%'} style={{padding: 5}}>
        <BodyCell>
          <CheckBoxDisable isCheck={false} disabled={true} checkItemHandeler={()=>{return}} style={{cursor:'default', marginRigth: 10}}/>
        </BodyCell>
      </CustomCell>
      <CustomCell width={'10%'} style={{padding: 5}}>
        <BodyCell >
          <div style={{display:'flex', justifyContent:'center', alignItems:"center" ,backgroundColor:'#d5d5d5', width: 60, height:60 }} >
            <RotatedImage alt=''  src={images.img_generating2}  style={{width: 40}}/>
          </div>
          
        </BodyCell>
      </CustomCell>
      <CustomCell width={'50%'} style={{ padding: 0,  }} align="center">
        <div style={{display:'flex', flexDirection:'column'}}>
          <div 
            style={{
            fontFamily: 'NSCJKrR',
            color: 'black',
            fontSize: 14,
          }}>
            {t('generating_image')}
          </div>
          <div 
            style={{
            fontFamily: 'NSCJKrR',
            color: '#686868',
            fontSize: 12,
          }}>
            {item.input_time.substring(0, 16).replace(/-/gi, '.')}{' '}
          </div>
        </div> 
      </CustomCell>
      <CustomCell width={'30%'} align="center">
        <InActiveBtn style={{padding:isMobile?'0px 10px' :'0px 20px'}}>
          {isMobile ? t('go_detail_mobile') : t('go_detail')}
        </InActiveBtn>
      </CustomCell>
    </TableRow>
  ):(
    <TableRow key={`list-${index}`} style={{borderBottom: '1px solid #cccccc',}}>
      <CustomCell width={'3%'}>
        <BodyCell>
          {/* <CheckBox id={item.idx} isCheck={checkboxes.has(item.idx)} checkItemHandeler={checkItemHandeler}/> */}
          <CheckBox
            onClick={() => checkItemHandeler(item.idx)}
            style={{ margin: 15 }}
            key={'all'}
          >
            <CheckMark checked={checkboxes.has(item.idx)} />
          </CheckBox>
        </BodyCell>
      </CustomCell>
      <CustomCell width={'10%'}>
        <BodyCell>
          <img alt='' src={item.res_thumb_path} style={{width:'100%', maxHeight: 60, cursor: 'pointer', objectFit: 'cover'}} onClick={()=>{goDetail(item.idx)}}/>
        </BodyCell>
        {/* <CheckBox
          onClick={() => this.onCheckAll()}
          style={{ margin: 15 }}
          key={'all'}
        >
          <CheckMark checked={isChecked} />
        </CheckBox> */}
      </CustomCell>
      <CustomCell width={'50%'} style={{ padding: 0,  }} align="center">
        <div style={{display:'flex', flexDirection:'column', cursor: "pointer"}} onClick={()=>{goDetail(item.idx)}}>
          <div 
            style={{
            fontFamily: 'NSCJKrB',
            color: 'black',
            fontSize: 'clamp(0.6875rem, 0.5313rem + 0.5vw, 0.8125rem)',
          }}>
            {item.img_name}
          </div>
          <div 
            style={{
            fontFamily: 'NSCJKrR',
            color: '#686868',
            fontSize: 'clamp(0.625rem, 0.4688rem + 0.5vw, 0.75rem)',
          }}>
            {item.input_time.substring(0, 16).replace(/-/gi, '.')}{' '}
          </div>
        </div> 
      </CustomCell>
      <CustomCell width={'30%'} align="center">
        <ActiveBtn style={{padding:isMobile?'0px 10px' :'0px 20px'}} onClick={()=>{goDetail(item.idx)}}>
          {isMobile ? t('go_detail_mobile') : t('go_detail')}
        </ActiveBtn>
      </CustomCell>
    </TableRow>
  )}
  </>
  )
}

export const ActiveBtn = ({ onClick, children, style }) => {
  return (
    <>
    <MediaQuery min={800}>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div
        onClick={onClick}
        style={{
          fontFamily: 'NSCJKrB',
          color: 'white',
          fontSize: 'clamp(0.625rem, 0.3125rem + 1vw, 0.875rem)',
          height: 32,
          padding: '0px 20px',
          backgroundColor: '#fe8b07',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 5,
          border: '1px solid #fe8b07',
          ...style,
        }}
      >
        {children}
      </div>
    </div>
    </MediaQuery>
    <MediaQuery max={799}>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div
        onClick={onClick}
        style={{
          fontFamily: 'NSCJKrB',
          color: 'white',
          fontSize: 'clamp(0.625rem, 0.5469rem + 0.25vw, 0.6875rem)',
          maxHeight: 32,
          padding: '0',
          backgroundColor: '#fe8b07',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 5,
          border: '1px solid #fe8b07',
          ...style,
        }}
      >
        {children}
      </div>
    </div>
    </MediaQuery>
    </>
   
  );
};

export const InActiveBtn = ({ onClick, children, style }) => {
  return (
    <>
    <MediaQuery min={800}>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div
        onClick={onClick}
        style={{
          fontFamily: 'NSCJKrB',
          color: '#686868',
          fontSize: 'clamp(0.625rem, 0.3125rem + 1vw, 0.875rem)',
          height: 32,
          padding: '0px 20px',
          backgroundColor: '#D9D9D9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 5,
          border: '1px solid #D9D9D9',
          ...style,
        }}
      >
        {children}
      </div>
    </div>
    </MediaQuery>
    <MediaQuery max={799}>

    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div
        onClick={onClick}
        style={{
          fontFamily: 'NSCJKrB',
          color: '#686868',
          fontSize: 'clamp(0.625rem, 0.5469rem + 0.25vw, 0.6875rem);',
          maxHeight: 32,
          padding: '0px',
          backgroundColor: '#D9D9D9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 5,
          border: '1px solid #D9D9D9',
          width:'max-content',
          ...style,
        }}
      >
        {children}
      </div>
    </div>

    </MediaQuery>
    </>
    
  );
};

export const CheckBoxChecker = ({checked, product_id, convertingArray, downloadingArray}) => {
  let types = '';
  for (let item of convertingArray) {
      if (parseInt(item) === product_id) {
          types = 'disable';
          break; // 중단
      }
  }
  for (let item of downloadingArray) {
    if (parseInt(item[0]) === product_id) {
        types = 'disable';
        break; // 중단
    }
  }

  return (
    <>
      { types === 'disable' ? 
        <label style={{marginRight:10}}>
          <input 
            id={product_id} 
            disabled={true}
            type="checkbox" 
            style={{cursor:'pointer', zoom: 1.3, accentColor: '#fe8b07'}}
          />
      </label>:
       <>
        <MediaQuery min={550}>
          <img
            alt=""
            src={checked ? images.icon_checked : images.icon_checknor}
            style={{ height: 18, width: 'auto', marginRight: 10, marginTop: 2 }}
          />
        </MediaQuery>
        <MediaQuery max={549}>
          {/* <img
            alt=""
            src={checked ? images.icon_checked : images.icon_checknor}
            style={{ height: 18, width: 'auto', marginRight: 6, marginTop: 2 }}
          /> */}
          <div style={{display:"flex", alignItems:"center", justifyContent: "center"}}>
            <img
              alt=""
              src={checked ? images.icon_checked : images.icon_checknor}
              style={{ height: 18, width: 'auto', }}
            />
          </div>
        </MediaQuery>
      </>
      }
    </>
  )
}


export const CheckBoxDisable = ({key, id, isCheck, checkItemHandeler, checkboxes, disabled, style, idx, Array}) => {

  return (
    <label style={{marginRight:10}}>
      <input 
        id={id} 
        disabled={disabled}
        type="checkbox" 
        checked={isCheck} 
        onChange={() => checkItemHandeler(id)}
        style={{cursor:'pointer', zoom: 1.3, accentColor: '#fe8b07', ...style}}
      />
    </label>
  )
}


export const DeleteCheckModal = ({ show, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const totoalWidth = window.innerWidth; //전체 화면 크기
  let modalWidth;

  if(totoalWidth < 500){
    modalWidth = 'clamp(120px, 90vw, 480px)';
  }else {
    modalWidth = 'calc(40% - 30px)';
  }

  return (
    <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }} open={show} onClose={onClose}>
      <Fade in={show}>
        <ModalContents style={{ width: modalWidth, }} onClose={onClose}>
          <ModalTitle>{t('check_item_delete_title')}</ModalTitle>
          <div
            style={{
              display: 'flex',
              borderTop: '1px solid #eeeeee',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              paddingTop: 10,
            }}
          >
            <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
            <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 'clamp(0.59375rem, -0.0703rem + 2.125vw, 1.125rem)', textAlign:'center', width: '80%'}}>{t('check_item_delete_content')}</div>
          </div>
          <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ModalNorBtn onClick={onClose} style={{ backgroundColor: '#cccccc', height: 54 }}>
              {t('check_item_delete_no')}
            </ModalNorBtn>
            <HorizontalSp sp={10} />
            <ModalNorBtn onClick={onConfirm} style={{ backgroundColor: '#ff8a06', height: 54 }}>
              {t('check_item_delete_yes')}
            </ModalNorBtn>
          </div>
        </ModalContents>
      </Fade>
    </Modal>
  );
};
